module.exports = __webpack_public_path__ + "img/ics_f_announce_yellow.bd550e00.svg";